import { render, staticRenderFns } from "./OrdensServicoFormItem.vue?vue&type=template&id=74377080&scoped=true&"
import script from "./OrdensServicoFormItem.vue?vue&type=script&lang=js&"
export * from "./OrdensServicoFormItem.vue?vue&type=script&lang=js&"
import style0 from "./OrdensServicoFormItem.vue?vue&type=style&index=0&id=74377080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74377080",
  null
  
)

export default component.exports